export const API_URL = 'https://ai-n8n.coverflex.com/webhook/e389ce8b-9209-489f-98e5-8ce5f2b2006a/chat';
// export const AUTH = 'Y292ZXJmbGV4YWxwaGF0ZXN0YWNjb3VudDEzMzphbG1hQm90ZWxobzQ1MA=='
